(() => {
  const SAFE_STYLE_FAMILIES = new Set([
    'ace vintage reissue guitar strap by d’andrea – vintage rock style – adjustable – fits electric, acoustic & bass',
    'thalia black chrome finish capo with aaa hawaiian koa inlay',
    'thalia black chrome finish capo with santos rosewood inlay',
  ]);
  const CATALOG_PICKER_SELECTOR = '.sigonna-catalog-navigator__picker';

  const normalize = (value) => value.replace(/\s+/gu, ' ').trim().toLocaleLowerCase('en-US');

  const cardTitle = (item) => {
    const heading = item.querySelector('.product-card__content :is(h3, h4, .h4)');
    return heading ? heading.textContent.trim() : '';
  };

  const cardImage = (item) => {
    const card = item.querySelector('product-card');
    return card?.dataset.featuredMediaUrl || item.querySelector('img')?.currentSrc || item.querySelector('img')?.src || '';
  };

  const cardLink = (item) => item.querySelector('.product-card__link')?.href || '';

  function renderFamily(items, title) {
    const primary = items[0];
    const content = primary.querySelector('.product-card__content');
    if (!content || content.querySelector('.sigonna-style-family')) return;

    const family = document.createElement('div');
    family.className = 'sigonna-style-family';

    const label = document.createElement('p');
    label.className = 'sigonna-style-family__label';
    label.textContent = `${items.length} styles available`;
    family.append(label);

    const links = document.createElement('div');
    links.className = 'sigonna-style-family__links';
    items.forEach((item, index) => {
      const href = cardLink(item);
      if (!href) return;
      const link = document.createElement('a');
      link.className = 'sigonna-style-family__link';
      link.href = href;
      link.setAttribute('aria-label', `View style ${index + 1} of ${items.length}: ${title}`);
      const imageUrl = cardImage(item);
      if (imageUrl) {
        const image = document.createElement('img');
        image.src = imageUrl;
        image.alt = '';
        image.loading = 'lazy';
        link.append(image);
      }
      links.append(link);
    });
    family.append(links);
    content.append(family);

    items.slice(1).forEach((item) => {
      item.hidden = true;
      item.dataset.sigonnaDuplicateHidden = 'true';
    });
  }

  function merchandiseGrid(grid) {
    const groups = new Map();
    grid.querySelectorAll(':scope > .product-grid__item:not([data-sigonna-duplicate-hidden])').forEach((item) => {
      const title = cardTitle(item);
      const key = normalize(title);
      if (!SAFE_STYLE_FAMILIES.has(key)) return;
      const family = groups.get(key) || [];
      family.push(item);
      groups.set(key, family);
    });
    groups.forEach((items) => {
      if (items.length > 1) renderFamily(items, cardTitle(items[0]));
    });
  }

  const merchandiseAll = () => document.querySelectorAll('.product-grid').forEach(merchandiseGrid);

  function closeCatalogPickers(exceptPicker = null) {
    document.querySelectorAll(`${CATALOG_PICKER_SELECTOR}[open]`).forEach((picker) => {
      if (picker !== exceptPicker) picker.removeAttribute('open');
    });
  }

  function enhanceCatalogPickers() {
    document.querySelectorAll(CATALOG_PICKER_SELECTOR).forEach((picker) => {
      if (picker.dataset.sigonnaPickerReady === 'true') return;
      picker.dataset.sigonnaPickerReady = 'true';
      picker.addEventListener('toggle', () => {
        if (picker.open) closeCatalogPickers(picker);
      });
    });
  }

  function syncHiddenSlide(slide) {
    if (!(slide instanceof Element) || !slide.matches('slideshow-slide[aria-hidden]')) return;
    slide.toggleAttribute('inert', slide.getAttribute('aria-hidden') === 'true');
  }

  function syncHiddenSlides(root = document) {
    if (root instanceof Element) syncHiddenSlide(root);
    root.querySelectorAll?.('slideshow-slide[aria-hidden]').forEach(syncHiddenSlide);
  }

  function initializeEnhancements() {
    merchandiseAll();
    enhanceCatalogPickers();
    syncHiddenSlides();
  }

  document.addEventListener('click', (event) => {
    const clickedPicker = event.target instanceof Element
      ? event.target.closest(CATALOG_PICKER_SELECTOR)
      : null;
    if (!clickedPicker) closeCatalogPickers();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const openPickers = Array.from(document.querySelectorAll(`${CATALOG_PICKER_SELECTOR}[open]`));
    if (openPickers.length === 0) return;
    const activePicker = openPickers.find((picker) => picker.contains(document.activeElement)) || openPickers.at(-1);
    closeCatalogPickers();
    activePicker?.querySelector('summary')?.focus();
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeEnhancements, { once: true });
  else initializeEnhancements();

  const observer = new MutationObserver((records) => {
    if (records.some((record) => Array.from(record.addedNodes).some((node) => node.nodeType === Node.ELEMENT_NODE))) {
      initializeEnhancements();
    }
    records.filter((record) => record.type === 'attributes').forEach((record) => syncHiddenSlide(record.target));
  });
  observer.observe(document.documentElement, { attributes: true, attributeFilter: ['aria-hidden'], childList: true, subtree: true });
})();
